import { render, staticRenderFns } from "./ImageGalleryResults.vue?vue&type=template&id=f1d680ba&"
import script from "./ImageGalleryResults.vue?vue&type=script&lang=js&"
export * from "./ImageGalleryResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports